import React from 'react';

import { isEmpty } from '@groww-tech-pvt/ella';
import { ReactIconComponentType } from '@groww-tech-pvt/icon-store';

const ScreenConfig = (props: Props) => {
  const { heading, subHeading, icon, customClass, actionCta } = props;

  if (isEmpty(heading) && isEmpty(subHeading) && isEmpty(icon)) return null;

  return (
    <>
      <div className={`flex items-start ${customClass}`}>
        <div className='flex flex-col gap-1.5 items-start'>
          <h1 className='displaySmall'>
            {heading}
          </h1>
          <p
            className={`leading-relaxed contentSecondary bodyBase`}
          >
            {subHeading}
          </p>
          {actionCta}
        </div>
       
      </div>
    </>
  );
};

type Props = {
  heading?: React.ReactNode;
  subHeading?: React.ReactNode;
  icon?: ReactIconComponentType | React.ReactNode;
  customClass?: string;
  actionCta?: React.ReactNode;
};

export default ScreenConfig;
